import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const OpportunityTagInput = () => {
  const { tagId = '' } = useParams();
  const decodedId = tagId ? atob(tagId) : tagId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityTag';

  useEffect(() => {
    if (tagId) { setIsEditing(true); fetchDetails(); }
  }, [tagId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunityTag'] + id + '/', { headers });
      setFormData(response.data?.data ?? response.data);
    } catch (error) { console.error('Error fetching Opportunity Tag details:', error); }
  };

  const fields = [{"name":"name","label":"Name","type":"text"},{"name":"color","label":"Color","type":"text"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Tag' : 'Create Opportunity Tag'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityTagInput;